import { Badge, Skeleton, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useGetSingleAbsenceQuery } from 'app/services/edpApiV1/absence';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { dataObjectForAbsencesTable, dataObjectForFormAbsences, sortingDate } from 'shared/helpers/utils';
import { TPreparedSingleAbsenceData, TPreparedSingleAbsenceTable } from 'shared/types/absence.types';
import AbsenceComment from '../AbsenceComment';
import AbsenceUserForm from '../absenceUserForm';
import style from './index.module.scss';

/**
 * @page Absence user archive
 */

const columns: ColumnsType<TPreparedSingleAbsenceTable> = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'key',
    width: 120,
  },
  {
    title: 'Дата',
    dataIndex: 'created',
    key: 'created',
    sorter: (a, b) => sortingDate(a.created, b.created),
  },
  {
    title: 'Период',
    dataIndex: 'period',
    key: 'period',
  },
  {
    title: 'ФИО',
    dataIndex: 'fio',
    key: 'fio',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: (status, render) => {
      return (
        <>
          <div>
            <Badge status={status.type} />
            {status.name}
          </div>
          {render?.zupRequestStatus?.type === 'processing' && (
            <div>
              <Badge className={style.badge} status="processing" />
              Документ формируется
            </div>
          )}
          {render?.zupRequestStatus?.type === 'success' && (
            <div>
              <Badge className={style.badge} status="success" />
              Документ сформирован
            </div>
          )}
          {render?.zupRequestStatus?.type === 'error' && (
            <div>
              <Badge className={style.badge} status="error" />
              Ошибка при формировании
            </div>
          )}
        </>
      );
    },
  },
];

const ReferencesUserArchive = () => {
  const { id } = useParams();
  const [dataAbsence, setDataAbsence] = useState<TPreparedSingleAbsenceData[]>();
  const tableData = useRef<TPreparedSingleAbsenceTable[]>();

  const { data: dataSingleAbsence, isLoading } = useGetSingleAbsenceQuery(id!, {
    skip: !id,
  });

  useEffect(() => {
    if (dataSingleAbsence) {
      const dataAbsence = dataObjectForFormAbsences(dataSingleAbsence);
      const dataForTable = dataObjectForAbsencesTable(dataSingleAbsence);
      tableData.current = dataForTable;
      setDataAbsence(dataAbsence);
    }
  }, [dataSingleAbsence]);

  return (
    <>
      <div className={style.wrap}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <>
            <Table scroll={{ x: true }} dataSource={tableData.current} columns={columns} pagination={false} bordered />
            {dataAbsence && <AbsenceUserForm dataAbsence={dataAbsence} />}
          </>
        )}
      </div>

      {dataAbsence && (dataAbsence[0]?.supervisorComment || dataAbsence[0]?.hrComment) && (
        <AbsenceComment dataAbsence={dataAbsence} />
      )}
    </>
  );
};

export default ReferencesUserArchive;
